<template>
    <DatasheetForm />
</template>
<script>
import DatasheetForm from './Form.vue'

export default {
  components: {
    DatasheetForm
  }
}
</script>
